




































































































































































































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { Billing, DEFAULT_BILLING } from "@/model/agreement/billing";
import AuthMixin from "@/mixins/authMixin";
import RulesMixin from "#/mixins/rulesMixin";
import UtilMixin from "@/mixins/utilMixin";

@Component
export default class extends Mixins(AuthMixin, RulesMixin, UtilMixin) {
  /** 事業所請求情報 */
  @Prop({ default: () => DEFAULT_BILLING }) billing!: Billing;

  /** 確定済みフラグ */
  @Prop({ default: false }) confirmed!: boolean;

  /** 解約・停止系項目を触ることができるかフラグ */
  @Prop({ default: false }) canChangeStopInput!: boolean;

  /** 削除確認ダイアログの表示フラグ */
  private isDeleteConfirmDialogVisible = false;

  /** AIルート機能がONか */
  private get IsAiOn(): boolean {
    return this.billing.is_ai_route_enabled == 1;
  }

  /** 削除開始日 */
  private get DialogDisplayMessage() {
    return this.billing.ai_route_delete_start_date
      ? this.dateToStr(
          this.newDate(this.billing.ai_route_delete_start_date),
          "yyyy年MM月dd日"
        ) + "以降のAI訪問予定を削除します。よろしいですか？"
      : "削除開始日を選択してください。";
  }

  /** バリデーションチェック:開始日 */
  private checkStartDate(date: string): boolean | string {
    // 機能OFFの場合は必須なし
    if (!this.IsAiOn) {
      return true;
    }

    // 機能ONの場合は必須
    if (!date) {
      return "必須項目です。";
    }

    return true;
  }

  /** バリデーションチェック:契約・課金開始日 */
  private checkAgreementAndBillingStartDate(date: string): boolean | string {
    // 機能OFFの場合は必須なし
    if (!this.IsAiOn) {
      return true;
    }

    // 機能ONの場合は必須
    // ただし、AI自動作成の無料公開期間後（1/1）
    const dNow = this.newDate("");
    const dStart = this.newDate("2025-01-01");

    if (dNow >= dStart && !date) {
      return "必須項目です。";
    }

    return true;
  }

  /** 終了日(未反映)欄を終了欄に反映 */
  private async copyEndDatePendingToEndDate() {
    await this.$openAlert(
      "終了日欄に反映します。\n保存ボタンを押して変更を確定してください。"
    );
    this.billing.ai_route_end_date = this.billing.ai_route_end_date_pending;
  }

  private clickDelete() {
    if (!this.billing.ai_route_delete_start_date) {
      this.$openAlert("削除開始日を選択してください。");
      return;
    }
    this.isDeleteConfirmDialogVisible = true;
  }

  /** 訪問予定の削除 */
  private async deleteVisitSchedule() {
    this.isDeleteConfirmDialogVisible = false;
    this.$emit(
      "delete-airoute-visit-schedules",
      this.billing.ai_route_delete_start_date
    );
  }
}
